
import { useState } from 'react';

const BlogSection = () => {
  const blogData = [
    {
      id: 1,
      image: 'https://public.readdy.ai/ai/img_res/ac79098d3251c228fd76e81e79589510.jpg',
      title: '10 скрытых жемчужин России, о которых мало кто знает',
      tag: 'Места',
      tagColor: 'bg-emerald-100 text-emerald-700'
    },
    {
      id: 2,
      image: 'https://readdy.ai/api/search-image?query=Travel%20gear%20equipment%20hiking%20boots%20backpack%20compass%20map%20outdoor%20adventure%20preparation%20professional%20photography%20organized%20clean%20background&width=400&height=300&seq=blog-tips-1&orientation=landscape',
      title: 'Как правильно собрать рюкзак для горного похода',
      tag: 'Лайфхаки',
      tagColor: 'bg-amber-100 text-amber-700'
    },
    {
      id: 3,
      image: 'https://readdy.ai/api/search-image?query=Successful%20mountain%20expedition%20team%20on%20summit%20celebrating%20achievement%20snow%20capped%20peaks%20professional%20adventure%20photography%20vibrant%20natural%20colors&width=400&height=300&seq=blog-reports-1&orientation=landscape',
      title: 'Отчет о восхождении на Эльбрус: 7 дней, которые изменили жизнь',
      tag: 'Отчеты',
      tagColor: 'bg-teal-100 text-teal-700'
    }
  ];

  return (
    <section className="bg-gray-50 py-16 md:py-20 lg:py-24" aria-labelledby="blog-heading">
      <div className="max-w-[1360px] mx-auto px-6">
        <div className="flex items-center justify-between mb-12">
          <h2 id="blog-heading" className="font-mulish font-bold text-3xl lg:text-4xl text-gray-900">
            Наш блог
          </h2>
          <a
            href="/blog"
            className="hidden md:inline-flex items-center gap-2 font-open-sans text-[#1E88E5] hover:text-[#0D47A1] font-semibold transition-colors duration-300 cursor-pointer"
          >
            Все статьи блога
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>

        {/* Карточки блога */}
        <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {blogData.map((article) => (
            <li key={article.id}>
              <article className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 h-full group">
                <a href="/blog" className="block h-full cursor-pointer">
                  <div className="aspect-[4/3] overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                  <div className="p-6">
                    <div className="mb-3">
                      <span className={`inline-block ${article.tagColor} text-sm font-mulish font-semibold px-3 py-1 rounded-full`}>
                        {article.tag}
                      </span>
                    </div>
                    <h3 className="font-mulish font-bold text-lg text-gray-900 group-hover:text-[#1E88E5] transition-colors duration-300 line-clamp-2 leading-tight">
                      {article.title}
                    </h3>
                  </div>
                </a>
              </article>
            </li>
          ))}
        </ul>

        {/* Кнопка для мобильной версии */}
        <div className="text-center mt-8 md:hidden">
          <a
            href="/blog"
            className="inline-flex items-center gap-2 font-open-sans text-[#1E88E5] hover:text-[#0D47A1] font-semibold transition-colors duration-300 cursor-pointer"
          >
            Все статьи блога
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default BlogSection;
